import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Card, Modal } from 'ui';
import { BetaFeedback, BetaLabel } from 'components/BetaProgram';
import EMAILS from 'constants/emails';
import LinkButton from 'components/shared/LinkButton';
import ZoomContext from 'components/InPersonTraining/shared/ZoomContext';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import Tooltip from 'components/shared/Tooltip';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Table from 'components/shared/table';
import {
  localTime,
  localTimeZone,
} from 'components/InPersonTraining/shared/LocalTimeAndTimeZone';
import DateFormat from 'constants/date_format';
import EditForm from '../Session/EditForm';
import SessionRegisterLink from '../Session/SessionRegisterLink';
import AddSessionForm from '../Session/AddSessionForm';
import Header from '../../Header';

class MultiSession extends Component {
  state = {
    addingSession: false,
    isSingleSessionView: false,
    currentSession: null,
    editing: false,
  };

  toggleAddingSession = () => {
    this.setState(state => ({ addingSession: !state.addingSession }));
  };

  toggleSingleSessionView = session => {
    this.setState({
      isSingleSessionView: true,
      currentSession: session,
    });
  };

  toggleEditing = () => {
    this.setState(state => ({ editing: !state.editing }));
  };

  render() {
    const { sessions, eventId, isArchived, meta, sessionCount } = this.props;
    const { addingSession, isSingleSessionView, currentSession, editing } =
      this.state;
    const { currentUser, currentCompany, zoomClientId } = meta;
    const formatDate = (date, format) =>
      moment(date, DateFormat.fixed.ISO8601_LOCAL).format(format);
    const sortedSessions = sessions.sort((a, b) =>
      a.start_time > b.start_time ? 1 : -1,
    );
    return (
      <ZoomContext.Provider value={{ zoomClientId }}>
        <Header currentSession={currentSession} />
        <Modal
          shown={addingSession}
          onDismiss={this.toggleAddingSession}
          canClickAway
          className="w-725p Modal-shell"
          enableFloatingDismiss
        >
          <Modal.Content>
            <div className="d-f fd-c">
              <h1 className="ff-ss ws-pr mr-8 mb-16">
                {t('in_person_training.event_overview.session.add')}
              </h1>
              <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('in_person_training.event_overview.max_sessions')}{' '}
              </Text>
            </div>
            <AddSessionForm
              eventId={eventId}
              currentUser={currentUser}
              currentCompany={currentCompany}
              onDismiss={this.toggleAddingSession}
            />
          </Modal.Content>
        </Modal>
        {currentSession && isSingleSessionView && (
          <Card className="EventSession">
            {editing && (
              <EditForm
                session={currentSession}
                currentUser={currentUser}
                currentCompany={currentCompany}
                onDismiss={this.toggleEditing}
              />
            )}
            {!editing && (
              <>
                <Card.Content className="fz-base" padding="medium">
                  <div className="d-f jc-sb ai-fs">
                    <div className="d-f fd-c">
                      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                        {/* {t('in_person_training.event_details')} */}
                        Session Details
                      </Text>
                    </div>
                    <div>
                      <Tooltip
                        text={
                          isArchived &&
                          t(
                            'in_person_training.event_overview.archived_cannot_be_edited',
                          )
                        }
                      >
                        <LinkButton
                          disabled={isArchived}
                          type="primary"
                          onClick={this.toggleEditing}
                        >
                          <Icon name="edit" className="mr-4" />
                          {t('common.edit')}
                        </LinkButton>
                      </Tooltip>
                    </div>
                  </div>
                  <SessionDetails
                    className="mt-20"
                    session={currentSession}
                    eventId={eventId}
                    adminView
                  />
                </Card.Content>
                <Card.Content
                  className="bg-gray-lightest bt-gray-lighter"
                  padding="large"
                >
                  <SessionRegisterLink
                    link={`${currentSession.urls.register}?shared=true`}
                  />
                </Card.Content>
              </>
            )}
          </Card>
        )}
        {!currentSession && !isSingleSessionView && (
          <Card className="EventSession">
            <>
              <Card.Content className="fz-base">
                <Table alternate>
                  <div className="d-f jc-sb ai-fs">
                    <div className="d-f pl-24 pt-24">
                      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                        {t('in_person_training.event_overview.sessions.title')}
                      </Text>
                      <BetaLabel whiteOnBlack className="ml-8 mr-8 mt-4" />
                    </div>
                    <div className="d-f pr-24 pt-24 fz-16">
                      <LinkButton
                        disabled={isArchived || sessionCount > 4}
                        type=""
                        className="pr-16 u-linkBtn"
                        onClick={this.toggleAddingSession}
                      >
                        <Icon name="add" className="mr-4" />
                        {t('in_person_training.event_overview.session.add')}
                      </LinkButton>
                      <BetaFeedback
                        className="d-f"
                        recipient={EMAILS.EVENTS_FEEDBACK}
                        betaFeatureName="Mult Session Events"
                      />
                    </div>
                  </div>
                  <Table.Header
                    key={`${currentCompany}.${currentUser}`}
                    className="EventSessionOverview-multiSessionHeader pr-6 pl-6"
                  >
                    <Table.Body.Cell>
                      <div>
                        {t('in_person_training.event_overview.session.title')}
                      </div>
                    </Table.Body.Cell>
                    <Table.Body.Cell>
                      <div>
                        {t('in_person_training.event_overview.instructor')}
                      </div>
                    </Table.Body.Cell>
                    <Table.Body.Cell>
                      <div>
                        {t('in_person_training.event_overview.location')}
                      </div>
                    </Table.Body.Cell>
                  </Table.Header>
                  {sortedSessions.map(session => (
                    <Table.Row
                      key={`${session.id}`}
                      className="EventSessionOverview-borderHidden"
                    >
                      <Table.Body.Cell className="pl-24">
                        <div>
                          <LinkButton
                            type=""
                            className="u-linkBtn"
                            onClick={() =>
                              this.toggleSingleSessionView(session)
                            }
                          >
                            {moment(
                              localTime(session.start_time),
                              DateFormat.fixed.ISO8601_LOCAL,
                            ).format(
                              DateFormat.fixed.SHORT_DAY_WITH_SHORT_MONTH,
                            )}
                            ,&nbsp;
                            {formatDate(
                              localTime(session.start_time),
                              DateFormat.TIME,
                            )}{' '}
                            -&nbsp;
                            {formatDate(
                              localTime(session.end_time),
                              DateFormat.TIME,
                            )}{' '}
                            {session.time_zone.formatted && localTimeZone()}
                          </LinkButton>
                        </div>
                      </Table.Body.Cell>
                      <Table.Body.Cell>
                        <div>{session.trainer.name}</div>
                      </Table.Body.Cell>
                      <Table.Body.Cell className="pr-24">
                        {session.location === '' &&
                          session.video_meeting !== null && (
                            <div>
                              {t(
                                'in_person_training.events_dashboard.video_conference',
                              )}
                            </div>
                          )}
                        {session.location !== '' &&
                          session.video_meeting === null && (
                            <div>{session.location}</div>
                          )}
                        {session.location !== '' &&
                          session.video_meeting !== null && (
                            <div>
                              {session.location},{' '}
                              {t(
                                'in_person_training.events_dashboard.video_conference',
                              )}
                            </div>
                          )}
                        {session.location === '' &&
                          session.video_meeting === null && <div>-</div>}
                      </Table.Body.Cell>
                    </Table.Row>
                  ))}
                </Table>
              </Card.Content>
            </>
          </Card>
        )}
      </ZoomContext.Provider>
    );
  }
}

const mapStateToProps = ({ event, meta }) => ({
  isArchived: event.is_archived,
});

export default connect(mapStateToProps)(MultiSession);
